import { ref, watch, computed, inject } from "vue"

export function useFieldsetState(props) {
  const formDisabled = inject("formDisabled", ref(false))
  const formReadonly = inject("formReadonly", ref(false))

  const disableComputed = computed(() => (props.formStateInheritanceDisabled ? props.disable : props.disable || formDisabled.value))
  const readonlyComputed = computed(() => (props.formStateInheritanceDisabled ? props.readonly : props.readonly || formReadonly.value))

  const isDirty = ref(false)

  watch(
    () => props.modelValue,
    () => {
      isDirty.value = true
    },
    { deep: true }
  )

  return { disableComputed, readonlyComputed }
}
